import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SignUp.css';
import logo from '../../assets/images/Logo.png';
import rectangle15 from '../../assets/images/Rectangle 15.png';
import { FaArrowRight } from "react-icons/fa6";
import { FaPodcast } from 'react-icons/fa6';
import { Modal, Button } from 'react-bootstrap';
import jana from '../../assets/images/reda.png';
import { CountrySelect, StateSelect, CitySelect } from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';



const SignUp = () => {
  const [showModal, setShowModal] = useState(false); // Contrôle du modal

  const [clinicName, setClinicName] = useState(''); // Valeur affichée dans l'input
  const [clinicAddress, setClinicAddress] = useState(''); // Valeur affichée dans l'input
  const [country, setCountry] = useState(null);
  const [currentState, setCurrentState] = useState(null);
  const [currentCity, setCurrentCity] = useState(null);
  const [telephone1, setTelephone1] = useState(''); // Téléphone 1
  const [telephone2, setTelephone2] = useState(''); // Téléphone 2
  const [currency, setCurrency] = useState(null);
  const [picture, setpicture] = useState(null);
  const navigate = useNavigate(); // Navigation
  const [errors, setErrors] = useState({});

  // Ouvrir et fermer le modal
  const handleInputClick = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  // Sauvegarde des sélections et mise à jour de l'adresse
  const handleSaveAddress = () => {
    const address = `${country?.name}, ${currentCity?.name}, ${currentState?.name}`;
    setClinicAddress(address); // Mise à jour de l'input
    handleCloseModal(); // Ferme le modal
  };

  const handleLogoChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setpicture(URL.createObjectURL(file)); // Crée une URL temporaire pour prévisualiser l'image
    }
  };

  const handleLoginClick = () => {
    navigate('/clientlogin');
  };

  const validateForm = () => {
    const newErrors = {};
    const phoneRegex = /^[+0-9]+$/; // Accepte uniquement les chiffres et le signe +

    if (!clinicName) newErrors.clinicName = "clinic's name is required";
    if (!clinicAddress) newErrors.clinicAddress = "clinic's address required";
    if (!country) newErrors.country = "clinic's country is required";
    if (!currentCity) newErrors.currentCity = "clinic's city is required";
    if (!currentState) newErrors.currentState = "clinic's department is required";
    if (!telephone1) {
      newErrors.telephone1 = "telephone 1 is required";
    } else if (!phoneRegex.test(telephone1)) {
      newErrors.telephone1 = "telephone 1 must contain only numbers and +";
    }
    if (!telephone2) {
      newErrors.telephone2 = "telephone 2 is required";
    } else if (!phoneRegex.test(telephone2)) {
      newErrors.telephone2 = "telephone 2 must contain only numbers and +";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  // Soumission du formulaire
  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      // Préparer les données à envoyer
      const selectedCountry = country?.name;
      const selectedCity = currentCity?.name;
      const selectedDepartment = currentState?.name;
      const formData = {
        clinicName,
        clinicAddress,
        selectedCountry,
        selectedCity,
        selectedDepartment,
        telephone1,
        telephone2,
        picture,
        currency
      };
      console.log(formData);

      // Rediriger avec les données du formulaire
      navigate('/ClientAdmin', { state: formData }); // Exemple de redirection avec les données du formulaire
    }
  };

  return (

    <div className="Signup-container">
      {/* Colonne droite */}
      <div className="Signup-signup-section">
        <div className="px-5">
          <div className="Signup-logo">MED<span className='simba'>TINZ</span></div>
          <h2 className="Signup-title">Create an account</h2>
          <div className="Signup-login-link">
            Already have an account?
            <a href="/login" className="Signup-login-link-text">Log in</a>
          </div>
          <form onSubmit={handleSubmit}>
            {/* Nom de la clinique */}
            <div className="form-floating mb-3 mt-2">
              <input
                type="text"
                className="form-control geste w-100"  // Ajout de w-100 pour garantir que le champ prenne toute la largeur
                id="floatingInput"
                placeholder="Clinic's name"
                value={clinicName}
                onChange={(e) => setClinicName(e.target.value)}
              />
              <label htmlFor="floatingInput">Clinic's name</label>
              {errors.clinicName && <span className="error">{errors.clinicName}</span>}
            </div>

            {/* Adresse de la clinique */}
            {/* Adresse de la clinique */}
            <div className="mb-3 col-12 mt-2 cecile">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control club"
                  placeholder="Clinic's address"
                  value={clinicAddress} // Affiche l'adresse mise à jour
                  onClick={handleInputClick} // Ouvre le modal
                  readOnly // Empêche la saisie manuelle
                />
                <span className="unit">
                  <FaPodcast />
                </span>
              </div>
              {errors.clinicAddress && <span className="error">{errors.clinicAddress}</span>}
            </div>


            {/* Modal Bootstrap */}
            <Modal show={showModal} onHide={handleCloseModal} centered>
              <Modal.Header closeButton>
                <Modal.Title>Address <FaPodcast className="dill" /></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {/* Pays */}
                <div className="form-group w-100 custom-select-container mb-3">
                  {/* Country Select */}
                  <CountrySelect
                    containerClassName="custom-select"
                    onChange={(_country) => setCountry(_country)}
                    placeHolder="Select Country"
                  />
                  {errors.country && <span className="error">{errors.country}</span>}
                </div>

                <div className="form-group w-100 custom-select-container mb-3">
                  {/* State Select */}
                  <StateSelect
                    countryid={country?.id}
                    containerClassName="custom-select"
                    onChange={(_state) => setCurrentState(_state)}
                    placeHolder="Select State"
                  />
                  {errors.currentState && <span className="error">{errors.currentState}</span>}
                </div>

                <div className="form-group w-100 custom-select-container mb-3">
                  {/* City Select */}
                  <CitySelect
                    countryid={country?.id}
                    containerClassName="custom-select"
                    stateid={currentState?.id}
                    onChange={(_city) => setCurrentCity(_city)}
                    placeHolder="Select City"
                  />
                  {errors.currentCity && <span className="error">{errors.currentCity}</span>}
                </div>

              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary"
                  onClick={handleSaveAddress}
                  disabled={!country || !currentCity || !currentState}
                >
                  Save changes
                </Button>
              </Modal.Footer>
            </Modal>

            {/* Téléphone */}
            <div className="d-flex justify-content-between mb-3 mt-2 phonefield">
              <div className="form-floating mb-3 flex-fill me-2">
                <PhoneInput
                  country={'bj'}
                  value={telephone1}
                  onChange={(phone) => setTelephone1(phone)}
                  inputClass="form-control geste w-100"  // Ajout de w-100 pour le rendre uniforme
                  placeholder="Telephone 1"
                />
                {errors.telephone1 && <span className="error">{errors.telephone1}</span>}
              </div>
              <div className="form-floating mb-3 flex-fill ms-2">
                <PhoneInput
                  country={'bj'}
                  value={telephone2}
                  onChange={(phone) => setTelephone2(phone)}
                  inputClass="form-control geste w-100"  // Ajout de w-100 pour le rendre uniforme
                  placeholder="Telephone 2"
                />
                {errors.telephone2 && <span className="error">{errors.telephone2}</span>}
              </div>
            </div>

            {/* Logo */}
            <div className="form-floating mb-3 mt-2 col-12">
              <input
                type="file"
                className="form-control geste w-100"
                name='picture'
                id="logoUpload"
                accept="image/*" // Limite l'upload aux fichiers images
                onChange={handleLogoChange}
              />
              <label htmlFor="logoUpload">Clinic's Logo</label>
              {errors.picture && <span className="error">{errors.picture}</span>}
            </div>

            {/* Devise */}
            <div className="form-floating mb-3 mt-2 col-12">
              <select
                className="form-control geste w-100"
                value={currency}
                onChange={(e) => setCurrency(e.target.value)}
              >
                <option value="">Select Currency</option>
                <option value="USD">USD</option>
                <option value="EUR">EUR</option>
                <option value="GBP">GBP</option>
                <option value="XOF">XOF</option>
                {/* Ajouter d'autres devises ici */}
              </select>
              <label htmlFor="currency">Currency</label>
              {errors.currency && <span className="error">{errors.currency}</span>}
            </div>


            {/* Bouton de soumission */}
            <button type="submit" className="btn w-100 mt-3 vyne">
              Continue <span className="admin-submit-arrow">→</span>
            </button>
          </form>
        </div>
      </div>

      {/* Colonne gauche */}
      <div className="Signup-preview-section">
        <div className="">
          <img src={jana} alt="jana" className="Signup-preview-image" />
          <div className="into mt-4">
            <div className="admin-preview-text">
              Manage your hospital with <span className="admin-highlight">ease</span> now..
            </div>
            <img src={rectangle15} alt="Group 208" className="Signup-morije" />
          </div>
        </div>
      </div>

      <div className="Signup-footer">
        © 2024 | Développé par ITTIQ
      </div>
    </div >

  );
};

export default SignUp;